<template>
  <div
    class="card position-relative p-2 shadow"
    :class="{ 'bg-red-300': item.status === 'OVERDUE' }"
  >
    <div class="card-body">
      <div class="d-flex flex-md-row flex-column justify-content-between">
        <template v-if="details.daysLate">
          <div
            class="position-absolute py-1 badge rounded-pill bg-danger text-white"
            style="margin-top:-24px; max-width: 120px; left: 16px"
          >
            {{ details.daysLate }} jour{{ details.daysLate === 1 ? '' : 's' }} de retard
          </div>
        </template>

        <div class="d-flex flex-column lead my-auto max-width-product-name">
          <div class="d-flex fw-bold mb-2">
            <v-highlight
              v-if="item.status !== 'OVERDUE'"
              :product-id="item.productId"
              :product-name="productName"
            />
            <div
              v-else
              class="text-pink-700"
            >
              {{ productName }}
            </div>
          </div>
          <div class="d-flex text-blue-700">
            N° {{ item.subscriptionReference }}
          </div>
          <div
            v-if="local"
            class="d-flex mt-2 fs-6 text-gray-600"
          >
            {{ local.address.street }}, {{ local.address.city }}
          </div>
        </div>

        <div class="d-flex flex-column ms-0">
          <div class="d-flex lead fw-bold mb-2 mt-md-0 mt-2 text-nowrap">
            {{ getPrice }}
          </div>
          <div class="d-none d-md-flex mb-2">
            {{ item.plan === 'ANNUAL' ? 'Annuel' : 'Mensuel' }}
          </div>
          <div class="d-none d-md-flex">
            {{ effectiveDate }}
          </div>
        </div>

        <div
          class="d-none d-md-flex my-auto text-center"
          :class="{ invisible: item.status === 'OVERDUE' }"
          style="max-width:100px; width: 100px"
        >
          <div
            class="badge badge-pill rounded-pill"
            :class="`bg-${formattedStatus.color} text-${formattedStatus.textColor || 'blue-700'}`"
          >
            <div class="d-flex flex-row">
              <span> {{ formattedStatus.text }} </span>
              <v-icon
                v-if="formattedStatus.icon"
                :icon="formattedStatus.icon"
                height="10"
                width="10"
                class="ms-1"
              />
            </div>
          </div>
        </div>

        <div
          class="d-flex flex-column flex-md-row my-auto justify-content-between"
          style="min-width:250px"
        >
          <v-download
            :action="downloadInvoiceItem"
            :inverse="item.status === 'OVERDUE'"
          />
          <v-loader
            title="Voir"
            :color="item.status === 'OVERDUE' ? 'pink-700': 'primary'"
            icon="arrow-white-right"
            :next="() => $router.push(`invoices/${item.id}`)"
          />
          <v-loader
            title="Télécharger"
            color="blue-600"
            class="d-md-none mt-1"
            icon="download-white"
            :next="downloadInvoiceItem"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable object-curly-newline */
import { mapGetters } from 'vuex';
import { toDateFrNumeric } from '@/utils/_Date';

import DownloadButton from '@/components/common/helpers/DownloadButton.vue';
import ProductHighlight from '@/components/common/helpers/ProductHighlight.vue';

export default {
  name: 'InvoiceDisplay',
  components: {
    'v-highlight': ProductHighlight,
    'v-download': DownloadButton,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      products: 'rater/products',
      contracts: 'contracts/get',
    }),
    subscription() {
      return this.contracts.find(({ id }) => id === this.item.subscriptionId)
       || {};
    },
    local() {
      if (this.subscription && this.subscription.productId === 16) {
        return this.subscription.risk.local;
      }
      return null;
    },
    effectiveDate() {
      return toDateFrNumeric(this.item.effectiveDate);
    },
    formattedStatus() {
      const status = [
        {
          id: 'PENDING',
          text: 'En attente',
          color: 'yellow-600',
          icon: 'warning',
        },
        {
          id: 'CHECKED_OUT',
          text: 'En attente',
          color: 'yellow-600',
          icon: 'warning',
        },
        {
          id: 'IN_PROGRESS',
          text: 'En cours',
          color: 'blue-400',
          textColor: 'white',
          icon: 'clock-white',
        },
        {
          id: 'PAID',
          text: 'Payée',
          color: 'green-400',
          icon: 'checkmark',
        },
        {
          id: 'CANCELLED',
          text: 'Résiliée',
          color: 'pink-700',
          textColor: 'white',
          icon: 'times-white',
        },
        {
          id: 'TERMINATED',
          text: 'Arrêtée',
          color: 'pink-700',
          textColor: 'white',
          icon: 'times-white',
        },
        {
          id: 'OVERDUE',
          text: 'En retard',
          color: 'pink-700',
          textColor: 'white',
        },
      ];
      return status
        .find(({ id }) => id === this.item.status)
        || {};
    },
    details() {
      return { daysLate: false };
    },
    getPrice() {
      const formattedPrice = parseFloat(this.item.yearly || 0)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        .replace('.', ',');
      return `${formattedPrice} €`;
    },
    productName() {
      return (this.products
        .find(({ id }) => id === this.item.productId) || {})
        .name;
    },
  },
  methods: {
    downloadInvoiceItem() {
      return this.$store.dispatch('download/downloadInvoiceItemPreview', this.item.id);
    },
  },
};
</script>
<style scoped>
@media screen and (min-width: 576px) {
  .max-width-product-name {
    width: 300px;
    max-width: 300px;
  }
}
</style>
